import React from 'react'
import CloseAccount from 'src/app/CloseAccount/CloseAccount'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { closeAccountRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const CloseAccountAppRoute: AppRoute = {
  id: AppLocation.CloseAccount,
  routeProps: closeAccountRouteProps,
  component: <CloseAccount />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default CloseAccountAppRoute
